import "./bulkTestOrderListTableComponent.scss";
import React, {useCallback} from "react";
import {ITableColumn} from "../../../shared/models/table.model";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {CommonService} from "../../../shared/services";
import {APIConfig} from "../../../constants";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import commonService from "../../../shared/services/common.service";

interface BulkTestOrderListTableComponentProps {
    filterData?: {};
}

const BulkTestOrderListTableComponent = (props: BulkTestOrderListTableComponentProps) => {
    const {filterData} = props;

    const columns: ITableColumn[] = [
        {id: 'id', label: 'Session ID', width: 100, isDefaultColumn: true, sortable: false, fixed: 'left'},
        {id: 'title', label: 'Title', isDefaultColumn: true},
        {id: 'facilityDetails.name', label: 'Facility Name', isDefaultColumn: true},
        {id: 'locationDetails.name', label: 'Location Name', isDefaultColumn: true},
        {
            id: 'physicianDetails', label: 'Ordering Provider', sortable: false, isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {item?.physicianDetails?.firstName} {item?.physicianDetails?.lastName}
                </>
            )
        },
        {id: 'testDetails.name', label: 'Ordered Test', isDefaultColumn: true},
        {id: 'numberOfOrders', label: 'Test Samples', width: 120, sortable: false, isDefaultColumn: true},
        {
            id: 'addedBy', label: 'Added by', sortable: false, isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {item?.createdByDetails?.firstName}
                    {item?.createdByDetails?.lastName}
                </>
            )
        },
        {
            id: 'createdAt', label: 'Added Date & Time',
            isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {
                        item.createdAt ?
                            <>
                                {commonService.formatDate(item?.createdAt)}
                                &nbsp;|&nbsp;
                                {commonService.formatTime(item?.createdAt)} <br/>
                            </> : <> - </>
                    }
                </>

            )
        },
        {
            id: 'actions', label: '', isDefaultColumn: true,
            hideInColumnPreferences: true,
            fixed: 'right',
            content: (item: any) => (
                <ButtonComponent
                    color={'primary'}
                    size={'small'}
                    variant={'outlined'}
                    startIcon={<ArrowDownwardIcon/>}
                    handleClick={() => {
                        downloadResultExcel(item?.attachmentDetails)
                    }}
                >Download XLS</ButtonComponent>
            )
        },
    ];

    const downloadResultExcel = useCallback((attachmentDetails: any) => {
        CommonService.downloadFile(attachmentDetails.url, attachmentDetails.title || 'result.xlsx', 'xlsx')
    }, [])


    return (
        <>
            <div className="table-list-container">
                <TableWrapperV2Component
                    isPaginated={true}
                    columns={columns}
                    url={APIConfig.BULK_UPLOAD_TEST_ORDER_LIST.URL}
                    method={APIConfig.BULK_UPLOAD_TEST_ORDER_LIST.METHOD}
                    extraPayload={filterData}
                    isColumnFilterVisible={false}
                />
            </div>
        </>
    );

};

export default BulkTestOrderListTableComponent;
